import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { RESET } from 'action-creators/generic';
import {
  PENDING_TRAVELS_ADMIN_REQUEST,
  FETCH_PENDING_TRAVELS_ADMIN_SUCCESSFUL,
  FETCH_PENDING_TRAVELS_ADMIN_FAILURE,
} from 'action-creators/pendingTravels';
import { TravelsAwaitingResponse } from 'models/travelApproved';

export interface PendingTravelState {
  isLoading: boolean;
  travelsAwaitingResult: TravelsAwaitingResponse | null;
  error: boolean | null;
}

const initialState: PendingTravelState = {
  isLoading: false,
  travelsAwaitingResult: null,
  error: null,
};

const reducer: Reducer<PendingTravelState> = (state = initialState, action) => {
  switch (action.type) {
    case PENDING_TRAVELS_ADMIN_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_PENDING_TRAVELS_ADMIN_SUCCESSFUL:
      return {
        ...state,
        travelsAwaitingResult: action.payload.data,
        isLoading: false,
      };
    case FETCH_PENDING_TRAVELS_ADMIN_FAILURE:
      return {
        ...state,
        travelsAwaitingResult: null,
        error: action.payload,
        isLoading: false,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'pendingTravels',
  blacklist: ['isLoading', 'error'],
};

export default persistReducer(persistConfig, reducer);
